export const ITEM_SALE_GO_BUTTON_API = 'ITEM_SALE_GO_BUTTON_API'
export const ITEM_SALE_GO_BUTTON_API_SUCCESS = 'ITEM_SALE_GO_BUTTON_API_SUCCESS'

export const SUPPLIER_ON_PARTYTYPE_API = 'SUPPLIER_ON_PARTYTYPE_API'
export const SUPPLIER_ON_PARTYTYPE_API_SUCCESS = 'SUPPLIER_ON_PARTYTYPE_API_SUCCESS'

export const ITEMS_ON_GROUP_AND_SUBGROUP_API = 'ITEMS_ON_GROUP_AND_SUBGROUP_API'
export const ITEMS_ON_GROUP_AND_SUBGROUP_API_SUCCESS = 'ITEMS_ON_GROUP_AND_SUBGROUP_API_SUCCESS'

export const ITEM_SALE_REPORT_API_ERROR_ACTION = 'ITEM_SALE_REPORT_API_ERROR_ACTION'